import { Col, Form, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { ScenarioSectionProp } from ".";


const EstimateLikelihoodSection = (props: ScenarioSectionProp) => {

    const { t } = useTranslation();
    const {data} = props;

    return (
        <div className="section-wrapper">
            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbLikelihood")}
                    >
                        <span>{data.likelihood}%</span>
                    </Form.Item>
                </Col>

            </Row>


        </div>
    )
}

export default EstimateLikelihoodSection;